import type { ExternalTableSchema } from '@packages/table-builder';

export const performanceRulesTable: ExternalTableSchema = {
  metadata: {
    title: 'Performance Rules',
    entity: 'Performance Rule',
    description: 'List of performance rules for your company.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/performance-rule/performance-rule-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      EvaluationPeriodFrom: 'filters.createdFromDate',
      EvaluationPeriodTo: 'filters.createdToDate',
      RuleStatus: 'filters.ruleStatusId',
      EarnedStatus: 'filters.earnedStatus',
      ApprovalStatus: 'filters.approvalStatusId',
    },
    filters: [
      {
        name: 'createdFromDate',
        placeholder: 'Evaluation Period From',
        type: 'date',
      },
      {
        name: 'createdToDate',
        placeholder: 'Evaluation Period To',
        type: 'date',
      },
      {
        name: 'ruleStatusId',
        placeholder: 'Available Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/performance-rule/rule-available-status-list',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'earnedStatus',
        placeholder: 'Earned Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/performance-rule/rule-earnedl-status-list',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'approvalStatusId',
        placeholder: 'Approval Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/performance-rule/rule-approval-status-list',
          labelField: 'name',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    { field: 'ruleName', header: 'Rule Name', type: 'text', sortable: true, width: 200 },
    {
      field: 'createDate',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 150,
      align: 'center',
    },
    { field: 'createdBy', header: 'Created By', type: 'text', sortable: true, width: 200 },
    {
      field: 'evaluationPeriodFrom',
      header: 'Evaluation Start Date',
      type: 'date',
      width: 200,
      align: 'center',
    },
    {
      field: 'evaluationPeriodTo',
      header: 'Evaluation End Date',
      type: 'date',
      width: 200,
      align: 'center',
    },
    {
      field: 'minimumPercentage',
      header: 'Minimum',
      type: 'percentage',
      sortable: true,
      width: 80,
      align: 'center',
    },
    {
      field: 'maximumPercentage',
      header: 'Maximum',
      type: 'percentage',
      sortable: true,
      width: 80,
      align: 'center',
    },
    {
      field: 'approvalStatus',
      header: 'Approval Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Approved: 'success',
          Rejected: 'error',
          Pending: 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'availableStatus',
      header: 'Available Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Available: 'success',
          Unavailable: 'error',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'earnedStatus',
      header: 'Earned Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: { Earned: 'success' },
        defaultVariant: 'info',
      },
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_PERFORMANCE_RULE', label: 'View' },
      { id: 'EDIT_PERFORMANCE_RULE', label: 'Edit' },
      { id: 'SET_AVAILABLE_PERFORMANCE_RULE', label: 'Available' },
      { id: 'SET_UNAVAILABLE_PERFORMANCE_RULE', label: 'Unavailable' },
      { id: 'APPLY_EARN_MULTIPLIER_PERFORMANCE_RULE', label: 'Apply Earn Multiplier' },
      { id: 'VIEW_COMMENTS_PERFORMANCE_RULE', label: 'View Comments' },
      { id: 'DELETE_PERFORMANCE_RULE', label: 'Delete', variant: 'danger' },
    ],
    bulk: [{ id: 'BULK_APPLY_EARN_MULTIPLIER_PERFORMANCE_RULE', label: 'Apply Earn Multiplier' }],
    toolbar: {
      primary: {
        id: 'ADD_PERFORMANCE_RULE',
        label: 'Add Performance Rule',
        icon: 'add_circle',
      },
      secondary: [
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [{ id: 'DOWNLOAD_TEMPLATE_PERFORMANCE_RULE', label: 'Download Template' }],
        },
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [{ id: 'IMPORT_PERFORMANCE_RULE', label: 'Import Bulk XLS' }],
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id' },
    columnPreferences: {
      persistenceKey: 'Performance Rule',
      resizable: true,
      reorderable: true,
    },
  },
};
